import * as React from "react";
import { forwardRef } from "react";
const SvgCheckGreenCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#0ACF83" }), /* @__PURE__ */ React.createElement("path", { d: "M9.52501 17.657L4.57501 12.707L5.98901 11.293L9.52651 14.8265L9.52501 14.828L18.01 6.343L19.424 7.757L10.939 16.243L9.52601 17.656L9.52501 17.657Z", fill: "white" }));
const ForwardRef = forwardRef(SvgCheckGreenCircle);
export { ForwardRef as ReactComponent };
